function megaslider() {

	let i;
	let hash = window.location.hash;
	let stop = false;
	let modal = false;

	if (hash != '') {
		i = hash.split('-', 2)[1];
		let top = $('.megaslider').offset().top;
		window.scrollBy(0, top - 88);
	} else {
		i = 1;
	}

	function changeLogic() {
		$('.megaslider-slide.active').animate({
			left: '-60%'
		},900, function() {
			$('.megaslider-slide').not('.megaslider-slide.active').css({
				left: '100%'
			});
		}).removeClass('active');

		$('.megaslider-slide__'+i).animate({
			left: '0px'
		},700).addClass('active');

		// $('.megaslider-slide .megaslider-btns').fadeOut().css({right: '-300px'});

		// $('.megaslider-slide__'+i+' .megaslider-btns').fadeIn().animate({right: '30px'},300);
	}

	function change(i) {

		if (!modal) {
			changeLogic();
		}else {
			$('.megaslider-photos').fadeOut();
			// $('.megaslider-slide.active .slide-text').slideToggle();
			$('.megaslider-path__content .megaslider-slide.active .slide-banner').fadeIn();
			$('.megaslider-btn__next-slide').fadeIn(50);
			$('.megaslider-btn__close-photos').fadeOut(50);
			modal = false;

			setTimeout(function(){
				changeLogic();
			},600);
		}

		window.location.replace(window.location.pathname+'#slide-'+i);
	}

	$('.megaslider-btns .btn-photo').click(function(e) {
		e.preventDefault();

		$('.megaslider-photos').fadeIn(); //delay
		// $('.megaslider-slide.active .slide-text').slideToggle(300);
		$('.megaslider-path__content .megaslider-slide.active .slide-banner').fadeOut(); //delay
		$('.megaslider-btn__next-slide').fadeOut(50);
		$('.megaslider-btn__close-photos').fadeIn(50);
		modal = true;

		return false;
	});

	$('.megaslider-btn__close-photos').click(function(e){
		e.preventDefault();

		$('.megaslider-photos').fadeOut();
		// $('.megaslider-slide.active .slide-text').slideToggle();
		$('.megaslider-path__content .megaslider-slide.active .slide-banner').fadeIn();
		$('.megaslider-btn__next-slide').fadeIn(50);
		$('.megaslider-btn__close-photos').fadeOut(50);
		modal = false;


		return false;
	});

	$('.megaslider-nav a').click(function(e){
		e.preventDefault();

		if($(this).parent().hasClass('active')) return false;

		i = $(this).attr('data-slide-index');

		change(i);

		$('.megaslider-nav a').parent().removeClass('active');
		$(this).parent().addClass('active');

		return false;
	});

	$('.megaslider-btn__next-slide').click(function(e){
		e.preventDefault();

		if(i >= $('.megaslider-slide').length / 2 ) i = 0;

		i++;

		$('.megaslider-nav a').parent().removeClass('active');


		$('.megaslider-nav a[data-slide-index='+i+']').parent().addClass('active');

		window.location.replace(window.location.pathname+'#slide-'+i);

		change(i);

		return false;
	});

	this.init = function() {
		$('.megaslider-nav a[data-slide-index='+i+']').parent().addClass('active');
		$('.megaslider-slide.megaslider-slide__'+i).addClass('active');
		$('.megaslider-slide.megaslider-slide__'+i).css({
			left: '0px'
		});
	}

}

function megasliderMobile() {

	var bxSlider = null;
	let locale = $('html').attr('lang');
	$('.megaslider-mobile').on('change', '.megaslider-select', function(e) {


		$.ajax({
			url: '/'+locale+"/api/v1/ajax/getMegaSlider",
	        type: "POST",
	        cache: false,
	        data:{collection:$(this).val(),department:$('#department').val()},
	        beforeSend: function() {
	        	$('.megaslider-mobile__content .studio-slide').remove();

	            if (bxSlider !== null) {
	            	bxSlider.destroySlider();
	            	bxSlider = null;
	            }
	          
	        },
	        success: function(response){

	        	$('.megaslider-mobile__content').append(response);
	        	
	        },
	        complete: function() {
	        	bxSlider = $('.megaslider-mobile__photos').bxSlider({
					pager: false,
					controls: true,
					preventDefaultSwipeX: false,
					preventDefaultSwipeY: false,
					touchEnabled: false,
					oneToOneTouch: false,
				});
	        }
		});


		return false;
	});

	this.init = function() {
		$('.megaslider-mobile__photos').bxSlider({
			pager: false,
			controls: true,
			preventDefaultSwipeX: false,
			preventDefaultSwipeY: false,
			touchEnabled: false,
			oneToOneTouch: false,
		});
	}
}

$( document ).ready(function() {
    

    if ($(window).width() >= 992) {
    	let mega = new megaslider();
    	mega.init();
    } else {
    	let mega = new megasliderMobile();
    	mega.init();
    }
});
